import React from 'react';
import {Button, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import { Visibility } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const Radio = ({radios, obtenerDocumentoAdjunto}) => {
  const classes = styles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
        {radios.map((radio, index) => (
          <Grid item xs={12} key={radio?.id || index}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TituloConIcono title={"Clasificación modulada"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'RADIO AM:'} label={ radio.radioAM ? "SI" : "NO" || ""}/>
                <ElementoDelCard title={'RADIO FM:'} label={ radio.radioFM ? "SI" : "NO" || ""}/>
              </Grid>
              <Grid item xs={12}>
                <TituloConIcono title={"Datos del SIT"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'Número de certificación y registro:'} label={radio.numeroCertificacionSit || ""}/>
                <ElementoDelCard title={'Fecha de vigencia hasta:'} label={functions.FormatearFecha(radio.fechaVigenciaSit || "") || ""}/>
                <Grid item xs={12} md={6} mt={2}>
                  <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 3, nombre: "radio", registroId: radio.id}, "pdfSit")} size="large">
                    <Visibility />
                    Ver constancia del SIT
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TituloConIcono title={"Datos de arrendamiento"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <ElementoDelCard title={'Es arrendatario:'} label={ radio.esArrendatario ? "SI" : "NO" || ""}/>
                {radio.esArrendatario ? (
                  <>
                    <ElementoDelCard title={'Fecha final:'} label={functions.FormatearFecha(radio.fechaFinArrenda || "") || ""}/>
                    <ElementoDelCard title={'Tiene autorización para transmitir Pro Política:'} label={ radio.autorizaProPolitica ? "SI" : "NO" || ""}/>
                    <Grid item xs={12} md={6} mt={2}>
                      <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 3, nombre: "radio", registroId: radio.id}, "pdfContratoArrenda")} size="large">
                        <Visibility />
                        Ver contrato
                      </Button>
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Radio;